var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcMenuDestinations = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66646 14.4333V12.0008C7.66646 11.5769 8.16089 11.3453 8.48655 11.6167L13.2055 15.5491C13.4454 15.749 13.4454 16.1174 13.2055 16.3173L8.48656 20.2499C8.16089 20.5212 7.66646 20.2897 7.66646 19.8657V17.4333H2.16646C1.33803 17.4333 0.666462 16.7617 0.666462 15.9333C0.666462 15.1048 1.33803 14.4333 2.16646 14.4333L7.66646 14.4333Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1333,
    cy: 16,
    r: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1666 22C23.4803 22 26.1666 19.3137 26.1666 16C26.1666 12.6863 23.4803 10 20.1666 10C18.2049 10 16.4631 10.9399 15.3659 12.4003L12.9674 10.5983C14.6069 8.41613 17.2216 7 20.1666 7C25.1372 7 29.1666 11.0294 29.1666 16C29.1666 20.9706 25.1372 25 20.1666 25C17.2216 25 14.6069 23.5839 12.9674 21.4017L15.3659 19.5997C16.4631 21.0601 18.2049 22 20.1666 22Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcMenuDestinations, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-menu-destinations.48431c55.svg";
export { ForwardRef as ReactComponent };